import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Dropdown, Tooltip, Badge } from "antd";
import messageIconHeader from "../../../assets/icons/messageIconHeader.svg";
import Nodification_Icon from "../../../assets/icons/Nodification_Icon.png";
import Notifications from "../../Notification/Notifications";

const NotificationDropdown = ({ windowDimensions }) => {
  const isNotificationCheck = localStorage.getItem("isNotificationCheck");
  const [isNotification, setisNotification] = useState(isNotificationCheck === "true");
  const [dropVisibleNotifications, setDropVisibleNotifications] = useState(false);
  const [isCountVisible, setIsCountVisible] = useState({ message: true, notification: true });

  const notificationUnreadCount = useSelector(
    (state) => state.fetchNotificationReducer.notificationUnreadCount
  );
  const conversationUnreadCount = useSelector(
    (state) => state.messagesReducer.conversationUnreadCount
  );

  if (windowDimensions.width <= 1000) return null;

  const handleNotificationClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setisNotification(true);
    setDropVisibleNotifications(true);
    localStorage.setItem("isNotificationCheck", true);
    setIsCountVisible((prev) => ({ ...prev, notification: true }));
  };

  const handleMessageClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setisNotification(false);
    setDropVisibleNotifications(true);
    localStorage.setItem("isNotificationCheck", false);
    setIsCountVisible((prev) => ({ ...prev, message: true }));
  };

  return (
    <>
      <div className="headerBtn headerBtnIcon">
        <Dropdown
          overlayClassName={`notification-dropdown ${!isNotification ? "notification-dropdown-message" : ""}`}
          overlay={
            <Notifications
              visible={setDropVisibleNotifications}
              closeModal={setDropVisibleNotifications}
              isTabSwitch={isNotification}
              setIsTabSwitch={setisNotification}
            />
          }
          onOpenChange={() => setDropVisibleNotifications(!dropVisibleNotifications)}
          placement="bottom"
          trigger={["click"]}
          open={dropVisibleNotifications}
          arrow
        >
          <Tooltip
            title="Notification"
            placement="bottom"
            overlayClassName="tooltip-notification"
            trigger={["click", "hover"]}
            mouseLeaveDelay={0}
            overlayStyle={{
              position: 'fixed',
            }}
          >
            <Badge
              offset={[-29, 8]}
              size="small"
              count={isCountVisible.notification ? notificationUnreadCount : 0}
              color="#fbdf50"
            >
              <span onClick={handleNotificationClick}>
                <img src={Nodification_Icon} alt="" style={{ padding: "0px 21px" }} />
              </span>
            </Badge>
          </Tooltip>
        </Dropdown>
      </div>

      <div className="headerBtn headerBtnIcon">
        <Tooltip
          title="Message"
          placement="bottom"
          overlayClassName="tooltip-message"
          trigger={["click","hover"]}
          mouseLeaveDelay={0}
          overlayStyle={{
            position: 'fixed',
          }}
        >
          <Badge
            offset={[-18, -3]}
            size="small"
            count={isCountVisible?.message ? conversationUnreadCount : 0}
            color="#db2828"
          >
            <span onClick={handleMessageClick}>
              <img src={messageIconHeader} alt="" style={{ padding: "0px 21px" }} />
            </span>
          </Badge>
        </Tooltip>
      </div>
    </>
  );
};

export default NotificationDropdown;